
/* injects from baggage-loader */

'use strict';

export default class AccountWidgetController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/components/account-widget/account-widget.controller.js